const initialState = {
  isProcessing: false,
  information: undefined,
  goals: undefined,
  investor: undefined,
};

const publicProfile = (state = { isProcessing: false }, action) => {
  switch (action.type) {
    case 'GET_USER_PUBLIC':
      return {
        ...state,
        isProcessing: true,
      };
    case 'RESET_USER_PUBLIC':
      return {
        initialState,
      };
    case 'GET_USER_PUBLIC_INFORMATION_SUCCESS':
      return {
        ...state,
        information: action.data,
      };
    case 'GET_USER_PUBLIC_GOALS_SUCCESS':
      return {
        ...state,
        goals: action.data,
      };
    case 'GET_USER_PUBLIC_INVESTORS_SUCCESS':
      return {
        ...state,
        investors: action.data,
      };
    case 'GET_USER_PUBLIC_FULLY_SUCCESS':
      return {
        ...state,
        ...action.data,
        isProcessing: false,
      };
    case 'GET_PUBLIC_GOAL':
      return {
        ...state,
        goal: action.data,
      };
    case 'GET_USER_PUBLIC_FAIL':
      return {
        error: action.error,
        isProcessing: false,
      };
    default:
      return state;
  }
};

export default publicProfile;
